import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  chip: {
    marginBottom: 8,
    marginInlineEnd: 5,
    backgroundColor: theme.palette.primary.lighter,
    '&:focus': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  chipOutline: {
    marginBottom: 8,
    marginInlineEnd: 5,
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      '& p': {
        color: 'white',
      },
    },
  },
  typeTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    color: '#3f505a',
  },
  radio: {
    color: '#b0bec5',
    marginInlineStart: theme.spacing(1),
  },
  tableCell: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    borderBottom: '1px solid rgba(109,114,120,0.2)',
  },
  table: {
    border: '1px solid rgba(109,114,120,0.18)',
    borderRadius: 4,
  },
  tableHeader: {
    background: '#eef1f5',
  },
  tableDataCell: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
}));